import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=4abaa9a7&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=4abaa9a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abaa9a7",
  null
  
)

export default component.exports